let language = {
    DELIVERY_ORDER_SUSPECTED_SANCTION_TIP: "This order cannot be processed!",
};

export { language }